import { apiClient } from '@/shared/lib/axios';
import { clinicApiPath } from '@/shared/lib/apiPath';
import type {
  ReturnRezeptListResponse,
  CancelReturnPayload,
  ResubmitPayload,
} from './types';

const BASE_PATH = '/rezepts/returns';

export async function fetchReturnRezeptList(
  siteType: string,
  clinicNumber: string
): Promise<ReturnRezeptListResponse['data']> {
  const res = await apiClient.get<ReturnRezeptListResponse>(
    clinicApiPath(siteType, clinicNumber, `${BASE_PATH}/`)
  );
  return res.data.data;
}

export async function cancelReturnRezepts(
  siteType: string,
  clinicNumber: string,
  payload: CancelReturnPayload
): Promise<void> {
  await apiClient.post(
    clinicApiPath(siteType, clinicNumber, `${BASE_PATH}/cancel`),
    payload
  );
}

export async function updateResubmissionMonth(
  siteType: string,
  clinicNumber: string,
  payload: ResubmitPayload
): Promise<void> {
  await apiClient.post(
    clinicApiPath(siteType, clinicNumber, `${BASE_PATH}/resubmit`),
    payload
  );
}

/**
 * RS-22 — 「編集を開始」. B19 stopped the sync branch from unlocking visits, so this is the only door a
 * clinic has to edit a rezept the sync returned.
 */
export async function startEditingReturnRezepts(
  siteType: string,
  clinicNumber: string,
  payload: CancelReturnPayload
): Promise<void> {
  await apiClient.post(
    clinicApiPath(siteType, clinicNumber, `${BASE_PATH}/start-editing`),
    payload
  );
}
